import { render, staticRenderFns } from "./newtovar.vue?vue&type=template&id=8c3e58e2&"
import script from "./newtovar.vue?vue&type=script&lang=js&"
export * from "./newtovar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports